import React, { Suspense } from 'react';
import { useTranslation } from 'react-i18next';
import { Box, CircularProgress, Typography } from '@mui/material';

const LoadingFallback = () => (
  <Box 
    sx={{ 
      display: 'flex', 
      flexDirection: 'column',
      alignItems: 'center', 
      justifyContent: 'center', 
      minHeight: '200px',
      gap: 2
    }}
  >
    <CircularProgress />
    <Typography variant="body2" color="textSecondary">
      Chargement des traductions...
    </Typography>
  </Box>
);

const TranslationWrapper = ({ children }) => {
  const { ready } = useTranslation();

  if (!ready) {
    return <LoadingFallback />;
  }

  return (
    <Suspense fallback={<LoadingFallback />}>
      {children}
    </Suspense>
  );
};

export default TranslationWrapper; 